<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Elective Allocation Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Academic Year"
                        outlined
                        @change="getStd();"
                        persistent-hint
                        hint="Please Select Academic Year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_std_data"
                        item-value="std_id"
                        :items="std_div_list"
                        item-text="std"
                        label="Standard"
                        outlined
                        persistent-hint
                        @change="getCourseOffering()"
                        hint="Please Select Standard"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="stream_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="stream"
                        :items="stream_list"
                        item-text="displayname"
                        item-value="id"
                        label="Stream"
                        outlined
                        persistent-hint
                        hint="Please Select Stream"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="subject_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="subject"
                        return-object
                        :items="subject_list"
                        item-text="name"
                        item-type="id"
                        label="Subject/Group"
                        outlined
                        persistent-hint
                        hint="Please Select Subject/Group"
                        multiple
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" class="pt-8 pl-2 mt-1" v-if="stream && sel_std_data && sel_ay_data && subject">
                    <v-btn color="primary" @click="fetchElectiveAllocationReport()" small> Fetch </v-btn>
                </v-col>
            </v-row>
            <v-data-table
                v-if="allocation_list!=''"
                :headers="headers"
                @current-items="getFiltered"
                :items-per-page="-1"
                :items="bookList1"
                sort-by=""
                class="elevation-1 mytable mt-10"
                :search="search"
            >

                <template v-slot:item.srno="{ item }">
                    {{ bookList1.indexOf(item) + 1 }}
                </template>

                <template v-slot:top class="pb-5">
                    <v-row justify="center" align="center">
                        <tr class="t-row">
                            <div>
                                <th>
                                    <v-row>
                                        <span v-for="header in headers" :key="header.text">
                                            <span v-if="filters.hasOwnProperty(header.value)">
                                                <v-autocomplete
                                                    class="mr-2 pb-5 pt-2"
                                                    flat
                                                    hide-details
                                                    small
                                                    rounded
                                                    dense
                                                    outlined
                                                    color="#0F2027"
                                                    :label="header.text"
                                                    multiple
                                                    clearable
                                                    :items="columnValueList(header.value)"
                                                    v-model="filters[header.value]"
                                                ></v-autocomplete>
                                            </span>
                                        </span>
                                    </v-row>
                                </th>
                            </div>
                        </tr>
                    </v-row>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    import { stream } from "xlsx";
    export default {
        components: {
            Breadcrumbs,
        },

        data() {
            return {
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                overlay: false,
                stream: null,
                subject: [],
                subject_list:null,
                allocation_list: [],
                filterArr: [],
                filters: {
                    registration_number: [],
                    name_of_candidate: [],
                    category: [],
                    course:[],
                },
                headers: [
                    { text: "Sr. No.", value: "srno" },
                    { text: "Choice No.", value: "preference_number" },
                    { text: "Registration Number", value: "registration_number" },
                    { text: "Student Name", value: "name_of_candidate" },
                    { text: "Subject", value: "course" },
                    { text: "Marks", value: "merit_marks" },
                    { text: "Email", value: "email" },
                    { text: "Mobile Number", value: "mobile_number" },
                    { text: "Category", value: "category" },
                    { text: "Academic Year", value: "ay" },
                    { text: "Standard", value: "standard" },
                    { text: "Stream", value: "stream" },
                ],
            };
        },
        computed: {
            bookList1() {
                return this.allocation_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },

        methods: {
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.allocation_list.map((d) => d[val]);
            },
            getCourseOffering() {
             this.subject_list = null
             this.subject = []
              const formData = {
                   ay: this.sel_ay_data.ay_id,
                   standard: this.sel_std_data,
              };
              axios
                  .post("/Examination/getSubjectGroupMixedList", formData)
                  .then((res) => {
                      if (res.data.flag == "Yes") {
                          this.subject_list = res.data.mixed_course_group_list;

                        this.subject_list = res.data.mixed_course_group_list.filter(
                            item => item.courserule === 'EL' && item.tdsg == null
                        );
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!");
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {});
          },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            async fetchElectiveAllocationReport() {

                if (!this.subject || this.subject.length === 0) {
                    this.showSnackbar("#b71c1c", "Please select at least one Subject/Group");
                    return;
                }

                const data = {
                    ay: this.sel_ay_data.ay_id,
                    std: this.sel_std_data,
                    stream: this.stream,
                    // subject: this.subject.id,
                    // subject_type: this.subject.selection_type
                    subjects: this.subject.map(s => ({
                        id: s.id,
                        type: s.selection_type
                    }))
                };
                try {
                    const res = await axios.post("/Admission/fetchElectiveAllocationReport", data);
                    if (res.data.flag == "YES") {
                        this.allocation_list = res.data.allocation_list;
                        if(this.allocation_list.length == 0){
                            this.showSnackbar("#b71c1c", "No Data Found....");
                        }
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally {
                }
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div_for_report_by_access")
                    .then((res) => {
                        console.log(res.data);
                        this.ay_std_div_list = res.data.data;
                        this.sel_ay_data = res.data.sel_ay_data;
                        this.stream_list = res.data.stream_list;
                        this.category_list = res.data.category_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
</style>
